<template>
  <!-- Toddy -->
  <div class="slcb-toddy__view-content">
    <Header :stepBack="stepBack" :previousNodo="previousNodo" :isClosing="isClosing" :isDone="isDone" @previousStep="previousStep"/>

    <!-- Messages -->
    <div id="terminal-chat" class="slcb-toddy__terminal-chat-container" v-bind:style="{minHeight: 'calc(100% - '+ boxInputHeight +'px)', maxHeight: 'calc(100% - '+ boxInputHeight +'px)'}" v-if="isDone" v-autobottom>
      <b-container>
        <b-row class="slcb-toddy__terminal-chat-row">
          <b-col id="terminal-chat-col" cols="12" md="10" offset-md="1">
            <template functional v-for="(item, index) in chatbot">
              <template functional v-if="item.step === 'intro'">
                <div :key="index" v-show="item.show">
                  <Question :question="item" :replace="form" @showBoxInput="showBoxInput" @nextStep="nextStep"/>
                  <Response :question="item" :letterIcon="letterIcon"/>
                </div>
              </template>

              <template functional v-else-if="item.step === 'score'">
                <div :key="index" v-show="item.show">
                  <Gauge :question="item" :points="points" @nextStep="nextStep"/>
                </div>
              </template>

              <template functional v-else>
                <div :key="index" v-show="item.show">
                  <Question :question="item" @showBoxInput="showBoxInput" @nextStep="nextStep"/>
                  <Response :question="item" :letterIcon="letterIcon"/>
                </div>
              </template>
            </template>
          </b-col>
        </b-row>
      </b-container>
    </div>

    <!-- Inputs -->
    <div id="terminal-input" class="slcb-toddy__terminal-input-bg-container" v-if="isDone && boxInput">
      <b-container class="slcb-toddy__terminal-input-container">
        <template functional v-for="(item, index) in chatbot">
          <template functional v-if="item.input.has">
            <div :key="index">
              <Input :question="item" :method="update" :field.sync="form[item.step]"/>
            </div>
          </template>
        </template>
      </b-container>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Question from '@/components/Question'
import Response from '@/components/Response'
import Input from '@/components/Input'
import Gauge from '@/components/Gauge'
import { VueTypedJs } from 'vue-typed-js'
import Chatbot from '@/models/Chatbot'
import Form from '@/models/Form'
import '@/directives/autobottom'
import * as axios from 'axios'

const BASE_URL = 'https://api.registrodemarca.silvalopes.adv.br/parse/v1/'

axios.defaults.headers = {
  'X-Parse-Application-Id': '6939e808daa0c434d3d0a68825a529ba',
  'X-Parse-REST-API-Key': '0e60ad33a2b549cab413f83b97713d6c',
  'Content-Type': 'application/json'
}

export default {
  name: 'Toddy',
  components: {
    'vue-typed-js': VueTypedJs,
    Header,
    Question,
    Response,
    Input,
    Gauge
  },
  data () {
    return {
      height: null,
      stepBack: false,
      previousNodo: null,
      steps: [],
      isClosing: false,
      isDone: false,
      boxInput: false,
      boxInputShow: false,
      boxInputHeight: '64px',
      letterIcon: 'a',
      points: 0,
      chatbot: {...Chatbot},
      form: {...Form}
    }
  },
  mounted () {
    document.body.style.minHeight = window.innerHeight + 'px'
    document.body.style.maxHeight = window.innerHeight + 'px'
    this.isStarting()
    this.$nextTick(() => {
      this.monitorHeight()
    })
  },
  computed: {
    getName () {
      return this.form.name
    }
  },
  methods: {
    isStarting: function () {
      setTimeout(() => {
        this.isClosing = true
        setTimeout(() => {
          this.isDone = true
          this.steps.push(this.chatbot[0])
        }, 2000)
      }, 2000)
    },
    showBoxInput: function (boolean) {
      if (boolean) {
        setTimeout(() => {
          const container = this.$el.querySelector('#terminal-input')
          this.boxInputHeight = (container.offsetHeight + 32)
        }, 0)
      } else {
        this.boxInputHeight = 64
      }
      this.boxInput = boolean
    },
    previousStep: function () {
      for (let index = this.steps.length - 1; index >= 0; index--) {
        if (this.steps[index] !== this.previousNodo) {
          this.steps[index].toddy = false
          this.steps[index].input = false
          if (this.steps[index].resposta) this.steps[index].resposta = null
          if (this.steps[index].fields) this.steps[index].fields = false
          this.steps.splice(index, 1)
          if (this.previousNodo.resposta) this.previousNodo.resposta = null
          this.previousNodo.input.show = true
          this.showBoxInput(true)
        } else {
          this.previousNodo = this.steps[index - 1]
          break
        }
      }
    },
    nextStep: function (self, value = null) {
      this.showBoxInput(false)
      setTimeout(async () => {
        if (self.step === 'end') await this.saveOnDB()
        this.previousNodo = this.chatbot[self.steps.previous]
        this.chatbot[self.steps.current].input.show = false
        const next = (self.input.type === 'boolean') ? this.chatbot[`${self.steps.next[`${value}`]}`] : this.chatbot[`${self.steps.next}`]
        next.show = true
        next.toddy = true
        if (next.input.has) next.input.show = true
        this.steps.push(next)
      }, 1000)
    },
    monitorHeight: function () {
      // Create a new mutation observer
      this.heightMonitor = new MutationObserver(this.checkHeight)
      // Start observing $el for an attribute, childlist, or subtree changes
      this.heightMonitor.observe(this.$el, {
        attributes: true,
        childList: true,
        subtree: true
      })
    },
    checkHeight: function () {
      let container = document.getElementById('terminal-chat')
      if (container === null || container === undefined) return true
      if (container.scrollHeight !== this.height && (container.scrollHeight - this.height) > 30) {
        container.scrollTop = container.scrollHeight
        this.height = container.scrollHeight
      }
    },
    update: async function (event, self, value) {
      if (self.step === 'greetings') await this.$router.push('/').catch(e => {})
      self.response.show = true
      self.response.value = (event.target.innerText) ? event.target.innerText : value
      this.form[self.step] = self.response.value
      this.nextStep(self, value)
      if (self.input.type === 'boolean' && self.hasOwnProperty('calc')) {
        if (value) {
          this.points += self.calc[`${value}`]
        } else {
          this.points -= self.calc[`${value}`]
        }
      }
    },
    saveOnDB: function () {
      const vm = this
      vm.form.ACL = {}
      vm.form.points = this.points
      let uri = `${BASE_URL}classes/Score`
      return new Promise(function (resolve, reject) {
        axios.post(uri, vm.form)
          .then(function (response) {
            resolve(true)
          })
          .catch(function (error) {
            reject(error)
          })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Toddy.vue